/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../utils/commonUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();

class GiftSteps extends Component {
  openPage = () => {
    browserHistory.push(applicationRoutes.createEvent);
  }
  render() {
    const data = this.props.StepsOfEventCreationsTypeTargeter && this.props.StepsOfEventCreationsTypeTargeter.data ? this.props.StepsOfEventCreationsTypeTargeter.data : null;
    return (
      <div dangerouslySetInnerHTML={{ __html: data }} />
    );
  }
}
export default GiftSteps;
